import Button from '@mui/material/Button';

const ExportOperStatCSV = ({ data, oper, chosenDate}) => {
    const downloadCSV = () => {
     
        console.log("Exporting!");
        console.log(oper);
        console.log(chosenDate);
 

        console.log("Starting");
        console.log(data);
        console.log(data[0])

      const csvString = [
        ["Referent", "Operator", "Razdoblje", 'Pristiglo', 'Odrađeno', 'Svi raniji zaostaci', 'Zaostaci iz tog perioda', 
            'Zaostaci kasnijeg perioda', 
            'Svi zaostaci danas'], 
        ...data.map(item => [oper?(oper.val_name?oper.val_name:'Svi'):'Svi', item.operator, item.razdoblje, item["pristiglo"], item["odradjeno"], item["svi_zaostaci_prije_nastali"], 
            item["zaostaci_iz_tog_perioda"], 
            item["zaostaci_kasnijeg_perioda"], item["svi_zaostaci_danas"]
        ]) 
      ]
      .map(row => row.join(","))
      .join("\n");
  
  
      const universalBOM = "\uFEFF";
      const csv = universalBOM + csvString;
      //const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8' });
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });

     
  

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');


      //const universalBOM = "\uFEFF";
      //link.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM+csvString));


      link.href = url;
      let fName = 'Statistika';
      if(oper && oper.val_username && oper.val_username!=''){
            fName = fName + '_' + oper.val_username;
      }

      console.log("Date");
      console.log(chosenDate)
      if(chosenDate && chosenDate!='' && chosenDate!='-'){

            console.log("Date is?");
            console.log(chosenDate);

            let checkedNew = chosenDate.split('.').join("");

            console.log(checkedNew);

            fName = fName + "_" + checkedNew;

      }else {
            console.log("Nije odabran datum!");
      }

      console.log(fName);

      if(fName != ''){

            fName = fName + '.csv';
      } else {

            fName = 'download.csv';
      }


      link.download = fName || 'download.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    };
  
    return <Button sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="info" 

                    onClick={() => {

                        console.log("Calling export!!!");

                        downloadCSV();

                    }}
             
                    >
                    Spremi u datoteku
            </Button>
    //return <button onClick={downloadCSV}>Spremi datoteku</button>;
  };
  
  export default ExportOperStatCSV;